
import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './css.css';
import { homeTabe } from '../../resource';

export default class SollTab extends Component {
    constructor(props) {
        super(props);

        this.characters = homeTabe

        this.titleIcoColor=require('../../config/titleBC.json')

  




    }

    getRandomInt=(min,max)=>{
        return Math.floor(Math.random()*(max-min+1))+min;
    }

    render() {
        console.log(this.titleIcoColor[0])
        const tabs = [];
        const tabPanels = [];
        let allData = []//All Projects

        //All Projects的数据由this.characters遍历出Data租成
        Object.keys(this.characters).forEach((name) => {
            if (this.characters[name].Data) {

                allData = allData.concat(this.characters[name].Data)

            }

        })



        Object.keys(this.characters).forEach((name ) => {


            const { img, color: backgroundColor, text: color, Data } = this.characters[name];

            tabs.push(
                <Tab style={{ backgroundColor },{display:"inline-block",marginRight:30,paddingTop:10,paddingBottom:10,cursor:"pointer"}} className="avengers-tab" key={name}>
                    <img src={img} alt={name} height="20" width="20" />
                    <span style={{ verticalAlign: "top", fontWeight: 500,marginLeft:10 }}>{name}</span>
                </Tab>
            );

            name === "All Projects" ?
                

                tabPanels.push(
                    <TabPanel style={{ color }, { display: "flex", flexWrap: "wrap" }} className="avengers-tab-panel" key={'All Projects'}>
                        {/* {desc} */}
                        {
                            allData && allData.map((atem, index) =>
                                <div className="project" style={{ display: "flex", flexDirection: "row", marginRight: "2vw", width: "29vw", marginBottom: "20px" }} key={index}>
                                    <span className="icon" style={{ backgroundColor:this.titleIcoColor[this.getRandomInt(0,this.titleIcoColor.length-1)][this.getRandomInt(0,4)], ...styles.leftBox} }>

                                        {atem.title[0]}
                                    </span>
                                    <a style={styles.a} href={atem.links} target="_blanket">
                                        <strong style={{marginRight:10}} data-v-6e499ef8="">
                                            {atem.title}
                                        </strong>
                                        {atem.body}
                                    </a>
                                </div>
                            )

                        }

                    </TabPanel>
                )
                :
                Data && tabPanels.push(
                    <TabPanel style={{ color }, { display: "flex", flexWrap: "wrap" }} className="avengers-tab-panel" key={name}>
                        {/* {desc} */}
                        {
                            Data && Data.map((atem, index) =>
                                <div className="project" style={{ display: "flex", flexDirection: "row", marginRight: "2vw", width: "29vw", marginBottom: "20px" }} key={index}>
                                    <span className="icon" style={{ backgroundColor: this.titleIcoColor[this.getRandomInt(0,this.titleIcoColor.length-1)][this.getRandomInt(0,4)],...styles.leftBox }}>

                                        {atem.title[0]}
                                    </span>
                                    <a style={styles.a} href={atem.links} target="_blanket">
                                        <strong style={{marginRight:10}} data-v-6e499ef8="">
                                            {atem.title}
                                        </strong>
                                        {atem.body}
                                    </a>
                                </div>
                            )

                        }

                    </TabPanel>
                )

        });

        return (
            <div style={{paddingLeft:20,paddingRight:20,height:300}}>
                {/* <p>{links}</p> */}
                <Tabs
                    selectedTabClassName="avengers-tab--selected"
                    selectedTabPanelClassName="avengers-tab-panel--selected"
                >
                    <TabList style={{display:'flex',flexDirection:'row',marginBottom:10,borderWidth:0,borderBottomWidth:1,borderColor:"#d3d3d3",borderStyle:"inset"}}  className="avengers-tab-list ">{tabs}</TabList>
                    {tabPanels}
                </Tabs>
            </div>
        );
    }


}


const styles = {
    a: {
        cursor: "pointer",
        width: "calc(100% - 70px)",
        color: "inherit",
        textDecoration: "none",
        fontWeight: "500",
        lineHeight: "1.5",
        marginLeft: "15px"
    },
    leftBox: {
        width: "40px",
        height: "40px",
    
        lineHeight: "40px",
        textAlign: "center",
        color: "#fff",
        fontWeight: 700,
        fontSize: "1.5rem",
        borderRadius: ".25rem",
        // background: "#264e8a",
        display: "block"
    },
    tabheader:{
        flexDirection:'row'
    }
}
